import React, { FC, useEffect, useState } from 'react';

import { AggregatedAlertDetails } from '@ariksa/notification/api';

import { PageHeaderWithIcon } from 'components/DataDisplay';

interface Props {
  finding: AggregatedAlertDetails;
}

export const FindingDrawerHeader: FC<Props> = props => {
  const { finding } = props;
  const [resourceType, setResourceType] = useState('');

  //get resourceType
  useEffect(() => {
    const resourceType = (finding as AggregatedAlertDetails)
      .resource_types?.[0];
    setResourceType(resourceType ?? '-');
  }, [finding]);

  return (
    <PageHeaderWithIcon
      label={finding.description}
      iconType={resourceType}
      labelStyles={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        w: '90%',
      }}
      iconSize="medium"
    />
  );
};
